import { Button, ButtonGroup, Fade, Grid } from "@material-ui/core"
import { useStyles } from "./roadmap-backlog-tipo-styles"
import { memo } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { useThemeQueries } from "views/theme"

export interface VotacoesDesenvolvimentoHeaderFiltrosProps {
}

export const RoadmapBacklogHeaderTipo = memo(({ ...props }: VotacoesDesenvolvimentoHeaderFiltrosProps) => {

    const history = useHistory()
    const location = useLocation()
    const classes = useStyles()
    const { isMobile } = useThemeQueries()

    const isEmVotacao = location.pathname.indexOf('/roadmap-backlog/em-votacao') > -1
    const isConcluido = location.pathname.indexOf('/roadmap-backlog/concluidos') > -1

    const handleClick = (value: 'votacao' | 'concluido') => {
        if (value === 'votacao') history.push('/roadmap-backlog/em-votacao')
        if (value === 'concluido') history.push('/roadmap-backlog/concluidos')
    }

    const color = isMobile ? "default" : "primary"

    return (
        <Fade in={true} mountOnEnter unmountOnExit>
            <Grid container spacing={2} className={classes.container}>
                <Grid item xs="auto">
                    <ButtonGroup variant="outlined" color="default" size="large">
                        <Button
                            onClick={() => handleClick('votacao')}
                            variant={isEmVotacao ? "contained" : "outlined"}
                            color={isEmVotacao ? color : "default"}
                        >
                            Em Votação
                        </Button>
                        <Button
                            onClick={() => handleClick('concluido')}
                            variant={isConcluido ? "contained" : "outlined"}
                            color={isConcluido ? color : "default"}
                        >
                            Concluídos
                        </Button>
                    </ButtonGroup>
                </Grid>
            </Grid>
        </Fade>
    )
})

RoadmapBacklogHeaderTipo.displayName = "RoadmapBacklogHeaderTipo"